import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@components/Loader';
import './SpecialitySelection.scss';

const staticText = {
  proceed: 'Proceed to doctor selection',
  errorMessage: 'Specialities not available',
};

const SpecialitySelection = ({
  specialitiesData,
  specialitiesTitle,
  specialitiesLoading,
  selectedSpeciality,
  onSelect,
}) => {
  if (specialitiesLoading && !specialitiesData.length) {
    return <Loader />;
  }

  const isSpecialistDataAvailable = specialitiesData && specialitiesData.length > 0;

  return (
    <div className="specialityContainer">
      {specialitiesTitle && <h1 className="specialityTitle">{specialitiesTitle}</h1>}
      {isSpecialistDataAvailable && (
        <div className="specialityList">
            {specialitiesData.map(speciality => {
              if (!speciality) return null;
              const { name, url, id, description } = speciality;
              return (
                <div
                  key={id}
                  className={`specialityCard ${selectedSpeciality === name ? 'selected' : ''}`}
                  onClick={() => onSelect(speciality)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && onSelect(speciality)}
                >
                  {url && <img className="specialityImage" width={56} height={56} src={url} alt={name} />}
                  <div className="specialityTextContainer">
                    <p className="specialityName">{name}</p>
                    {description && <p className="specialityDescription">{description}</p>}
                  </div>
                  <div className={`specialityRadio ${selectedSpeciality === name ? 'checked' : ''}`} />
                </div>
              );
            })}
        </div>
      )}
      {!specialitiesLoading && !isSpecialistDataAvailable && (
        <p className="specialityError">{staticText.errorMessage}</p>
      )}
    </div>
  );
};

SpecialitySelection.propTypes = {
  specialitiesData: PropTypes.array.isRequired,
  specialitiesTitle: PropTypes.string,
  specialitiesLoading: PropTypes.bool,
  selectedSpeciality: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

SpecialitySelection.defaultProps = {
  specialitiesTitle: '',
  specialitiesLoading: false,
  selectedSpeciality: '',
};

export default SpecialitySelection;
